(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "react", "react-ctx-connect"], b);else if ("undefined" != typeof exports) b(exports, require("react"), require("react-ctx-connect"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.react, a.reactCtxConnect), a.context = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c) {
  "use strict";

  var d = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.connectAuthProvider = a.context = void 0, b = d(b), c = d(c);
  var e = b.default.createContext();
  a.context = e;
  var f = (0, c.default)(e);
  a.connectAuthProvider = f;
  a.default = e;
});